import React from "react"
import { Transition } from "react-spring/renderprops"
import ShareIcon from "../components/ShareLinkIcons/ShareIcon"
import DownloadIcon from "../components/ShareLinkIcons/DownloadIcon"
import Layout from "../components/Layout"
import EventricSocialLinks from '../components/EventricSocialLinks'

const ThankYou = (props) => {
	props.addSection("ThankYou")
	let loaded = false
	const sectionIndex = props.sections.findIndex((section) => section === "ThankYou")
	if (props.destinationIndex === sectionIndex) {
		loaded = true
	}
	const titleContent = `Visit https://2025.eventric.com/${props.accountHash}`
	const urlContent = `https://2025.eventric.com/summ/${props.accountHash}.png`

	const mobileShare = () => {
		if (navigator.share) {
			navigator
				.share({
					url: urlContent,
					title: titleContent,
				})
				.catch(() => {
					console.log("Share cancelled.")
				})
		}
	}
	return (
		<Layout hideLogo={true}>
			<div style={styles.container}>
				{loaded && (
					<>
						<Transition from={{ opacity: 0 }} enter={{ opacity: 1 }}>
							{(item) => (styleProps) =>
								(
									<div style={styleProps}>
										<div style={styles.text}>
											<p>From all of us at Master Tour,</p>
											<p>may your 2026 be filled with full calendars, safe travels, and moments that remind you why you do what you do.</p>
											<p style={styles.textTwo}>Here’s to a year of magic, music, and making it all happen.</p>
											<p>
												<b>Happy New Year!</b>
											</p>
				
											{titleContent && (
												<div style={styles.socialContainer}>
													{navigator?.share ? (
														<div
															onClick={mobileShare}
															className="shareNative"
															style={styles.shareContainer}
														>
															<p style={styles.shareText}>Share</p>
															<ShareIcon size={"1em"} color={"#fff"} />
														</div>
													) : null}
													<a
														href={`https://2025.eventric.com/summ/${
															props.accountHash || "default"
														}.png`}
														target="_blank"
														rel="noopener noreferrer"
														download={props.titleContent}
														className="shareDownload"
														style={{ ...styles.shareContainer }}
													>
														<p style={styles.shareText}>Save</p>
														<DownloadIcon size={"1em"} color={"#fff"} />
													</a>
												</div>
											)}
										</div>
										<div style={styles.evContainer}>
											<div style={styles.evLogo}>
												<a href="https://www.eventric.com" target="_blank" rel="noopener noreferrer">
													<img
														src="https://cdn-eoy.eventric.com/img/logo-ev.png"
														alt="Eventric logo"
														style={styles.evLogo}
													/>
												</a>
											</div>
											<div style={{ fontSize: "2.2em" }}>
												<EventricSocialLinks />
											</div>
											<p style={styles.muted}>
												Eventric, INC. 1644 N. Honore Suite 301, Chicago, IL, 60622 USA
											</p>
											<p style={styles.muted}>© Eventric, INC., All Rights Reserved.</p>
										</div>
									</div>
								)}
						</Transition>
					</>
				)}
			</div>
		</Layout>
	)
}

const styles = {
	container: {
		alignItems: "center",
		display: "flex",
		flexDirection: "column",
		fontSize: "1em",
		justifyContent: "center",
		marginBottom: "1em",
		marginTop: "4em"
	},
	evContainer: {
		alignItems: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		fontSize: "0.4em",
		marginTop: "1em",
	},
	evLogo: {
		marginBottom: ".4em",
		maxWidth: 500,
		width: "15em",
	},
	muted: {
		color: "#999999",
		marginBottom: 10,
	},
	shareContainer: {
		borderRadius: "10px",
		cursor: "pointer",
		display: "flex",
		justifyContent: "center",
		padding: "0.5em 1em",
		margin: "0.5em 0.3em",
		textTransform: "uppercase",
	},
	shareText: {
		marginRight: 10,
	},
	socialContainer: {
		alignItems: "center",
		display: "flex",
		flexWrap: "wrap",
		fontSize: "0.75em",
		justifyContent: "space-around",
		margin: "2em auto 4em",
		maxWidth: "80%",
	},
	text: {
		maxWidth: "700px"
	},
	textTwo: {
		marginTop: "1em",
		marginBottom: "1em"
	}
}

export default ThankYou
